import type { ReactElement, ReactNode } from 'react';

export type AlertVariant =
  | 'red'
  | 'yellow'
  | 'green'
  | 'blue'
  | 'purple'
  | 'cyan'
  | 'orange'
  | 'indigo'
  | 'rose'
  | 'emerald'
  | 'amber'
  | 'teal'
  | 'gray';

const variants: Record<AlertVariant, string> = {
  red: 'bg-theme-danger/15 border-theme-danger/30 text-theme-danger',
  yellow: 'bg-theme-warning/15 border-theme-warning/30 text-theme-warning',
  green: 'bg-theme-success/15 border-theme-success/30 text-theme-success',
  blue: 'bg-theme-primary/15 border-theme-primary/30 text-theme-primary',
  purple: 'bg-purple-500/15 border-purple-500/30 text-purple-400',
  cyan: 'bg-cyan-500/15 border-cyan-500/30 text-cyan-400',
  orange: 'bg-orange-500/15 border-orange-500/30 text-orange-400',
  indigo: 'bg-indigo-500/15 border-indigo-500/30 text-indigo-400',
  rose: 'bg-rose-500/15 border-rose-500/30 text-rose-400',
  emerald: 'bg-theme-success/15 border-theme-success/30 text-theme-success',
  amber: 'bg-theme-warning/15 border-theme-warning/30 text-theme-warning',
  teal: 'bg-teal-500/15 border-teal-500/30 text-teal-400',
  gray: 'bg-theme-surface border-theme-border text-theme-text',
};

interface AlertBoxProps {
  variant?: AlertVariant;
  title?: string;
  children: ReactNode;
  className?: string;
}

export default function AlertBox({
  variant = 'blue',
  title,
  children,
  className = '',
}: AlertBoxProps): ReactElement {
  return (
    <div className={`border rounded-lg p-4 ${variants[variant]} ${className}`}>
      {title && <h3 className="font-bold mb-2">{title}</h3>}
      {children}
    </div>
  );
}
